module.exports = __webpack_public_path__ + "media/icons/two-people-e9f558d8.png";